// removed by extract-text-webpack-plugin
module.exports = {"main":"_3GsgDv5IRn2-mcVqwdOa6B","footer":"_2XBSmEfHjSCCtcGIkItYE5"};


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/App/styles.css
// module id = 1602
// module chunks = 0